module.exports = __webpack_public_path__ + "static/media/ACS SiteCon User Research Index.c7fb2799.xlsx";